import { render, staticRenderFns } from "./RegisterCarrito.vue?vue&type=template&id=01a05114"
import script from "./RegisterCarrito.vue?vue&type=script&lang=js"
export * from "./RegisterCarrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports